import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * @url /main, /whatewdo, /marketplace, /contactus, /community, /mypage
 * @CONST CONST.URL_MAIN, CONST.URL_WHATWEDO, CONST.URL_MARKETPLACE, CONST.URL_CONTACTUS, CONST.URL_COMMUNITY, URL_MYPAGE
 * @menu  마켓플레이스
 * @mapping 서비스 소개 화면 , Wath We Do 화면, 마켓플레이스 화면, 랜딩 상담신청, 커뮤니티, 마이페이지
 */
import { useCallback, useEffect, useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
// ex-module
import { checkSheetState, contactusState, detail, detailHistory, detailList, loadingBoxState, marketWork, urlState, } from "@recoil/menuState";
import * as CONST from "@utils/Const";
import { checkTypeState, curAdminTreeState, curMonitoringTreeState, curReportState, curSchduleTreeState, deviceState, mainState, noneUrl, todayState, } from "@recoil/assessmentState";
import { communityPageState } from "@recoil/userState";
//SEI Join
// Community Join
import CommonPopup from "@components/common/popup/CommonPopup";
import PortalPops from "@components/common/popup/pops/PortalPops";
import Logout from "@components/login/Logout";
import Footer from "@layout/footer/Footer";
import Header from "@layout/header/main/Header";
import MyAccount from "@layout/header/main/MyAccount";
import { langState } from "@recoil/langState";
import { Outlet } from "react-router-dom";
/**
 * @param props0 handleOpenPop : 레이어 팝업
 */
function MainPortalLayout() {
    // recoil
    const urlInfo = useRecoilValue(urlState);
    const langs = useRecoilValue(langState); // recoil langState
    const recoilNoneUrlInfo = useRecoilValue(noneUrl);
    const [loadingBox, setLoadingBox] = useRecoilState(loadingBoxState);
    const [recoilCommunityPage, setRecoilCommunityPageState] = useRecoilState(communityPageState);
    const [details, setDetils] = useRecoilState(detail);
    //초기화
    const resetCheckSheet = useResetRecoilState(checkSheetState);
    const resetRecoilTreeData = useResetRecoilState(curSchduleTreeState);
    const resetRecoilData = useResetRecoilState(curMonitoringTreeState);
    const resetRecoilAdminData = useResetRecoilState(curAdminTreeState);
    const resetCheck = useResetRecoilState(checkTypeState);
    const resetRecoilReportData = useResetRecoilState(curReportState);
    const resetRecoilToday = useResetRecoilState(todayState);
    const resetDeviceInfo = useResetRecoilState(deviceState);
    const resetRecoilMainState = useResetRecoilState(mainState);
    const resetRecoilDetailList = useResetRecoilState(detailList);
    const resetRecoilMarkerWorks = useResetRecoilState(marketWork);
    const resetRecoilHistory = useResetRecoilState(detailHistory);
    const resetReContactusState = useResetRecoilState(contactusState);
    useEffect(() => {
        if (!recoilNoneUrlInfo) {
            // 초기화
            resetCheckSheet();
            resetRecoilData();
            resetRecoilTreeData();
            resetRecoilAdminData();
            resetCheck();
            resetRecoilReportData();
            resetRecoilToday();
            resetDeviceInfo();
            resetRecoilMainState();
            resetRecoilMarkerWorks();
            resetRecoilHistory();
            resetReContactusState();
            resetRecoilDetailList();
            setRecoilCommunityPageState("LIST");
            setDetils(false);
            setLoadingBox(false);
            window.scrollTo({ top: 0 });
        }
    }, [urlInfo]);
    const [popId, setPopId] = useState("");
    const [popBody, setPopBody] = useState("");
    useEffect(() => {
        handleOpenPop("pop-alert", null);
    });
    const handleOpenPop = useCallback((popId, popBody) => {
        setPopId(popId);
        setPopBody(popBody);
    }, [popId, popBody]);
    const getClassName = (urlInfo) => {
        const baseUrl = urlInfo.split("?")[0];
        if (urlInfo === CONST.URL_MAIN) {
            return "serviceintro";
        }
        else if (urlInfo === CONST.URL_WHATWEDO) {
            return "whatwedo";
        }
        else if (baseUrl === CONST.URL_CONTACTUS) {
            return "consulting";
        }
        else if (baseUrl === CONST.URL_COMMUNITY ||
            baseUrl === CONST.URL_MYPAGE ||
            baseUrl === CONST.URL_VERIFYEMAILCOMMUNITY) {
            return "community";
        }
        else if (baseUrl === CONST.URL_DOWNLOAD) {
            return "download";
        }
        else {
            return "";
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "wrap", className: `page-market 
          ${details ? "detail" : ""}
          ${getClassName(urlInfo)}
          ${langs == CONST.STR_LANG_ENG ? "lang-eng" : ""}` }, { children: [_jsx(Header, {}), _jsx(Outlet, { context: { handleOpenPop } }), (urlInfo !== CONST.URL_COMMUNITY || recoilCommunityPage !== "LIST") && _jsx(Footer, {}), _jsx(Logout, { path: CONST.URL_MAIN }), _jsx(MyAccount, {}), _jsx(CommonPopup, {}), _jsx(PortalPops, { popId: popId, popBody: popBody })] })), _jsx("div", { className: "dimm" }), _jsx("div", Object.assign({ className: loadingBox ? "loading" : "" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) }))] }));
}
export default MainPortalLayout;
